<main role="main" class="not-home-page">
  <div class="row">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="banner"><img src="" alt="" /></div>
          <app-breadcrumb></app-breadcrumb>
        </div>
      </div>
      <div>
        <div class="row">
          <div class="col-lg-3 col-md-3 col-s-12">
            <nav id="sidebar">
              <app-statique-menu [lg]="outputLg" [cururl]="currentUrl"></app-statique-menu>
            </nav>
          </div>
          <div class="col-lg-9 col-md-9 col-s-12">
            <div id="container" *ngIf="confirmationMessage ===''">
              <!-- <div class="projects">Photothèque</div> -->

              <form role="form" #form1="ngForm">
                <mat-vertical-stepper linear #stepper>
                  <mat-step [stepControl]="first" #first="ngModelGroup" ngModelGroup="first">
                      <ng-template matStepLabel>Informations Candidat</ng-template>
                      <mat-expansion-panel [expanded]="true" [disabled]="true" hideToggle="true"
                        style="margin-top: 5px ;width: 100%;">
                        <mat-expansion-panel-header
                          style="background-color: #00bade;max-height:50px;align-content: center;">
                          <mat-panel-title class="accordeonTitle">
                            <strong> Situation</strong>
                          </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div style="display: inline-flex;">
                          <mat-label style="margin:10px;">Situation *: </mat-label> &nbsp;&nbsp;
                          <div>
                            <select required class="form-control" ngModel name="Situation" style="max-width: 200px;">
                              <option value="">Selectionner</option>
                              <option value="Candidat interne" title="Candidat (e) interne">Candidat (e) interne
                              </option>
                              <option value="Candidat  externe" title="Candidat (e) externe">Candidat (e) externe
                              </option>
                            </select>
                          </div>

                        </div>


                      </mat-expansion-panel>
                      <mat-expansion-panel [expanded]="true" [disabled]="true" hideToggle="true"
                        style="margin-top: 5px; width: 100%;">
                        <mat-expansion-panel-header style="background-color: #00bade;max-height:50px;">
                          <mat-panel-title class="accordeonTitle">
                            <strong> Identité</strong>
                          </mat-panel-title>
                        </mat-expansion-panel-header>
                        <mat-form-field>
                          <mat-label>Nom</mat-label>
                          <input name="Nom" ngModel matInput placeholder="Nom" required />
                        </mat-form-field>
                        <br />
                        <mat-form-field>
                          <mat-label>Prénom</mat-label>
                          <input name="Prenom" matInput ngModel placeholder="Prénom" required />
                        </mat-form-field>
                        <br />
                        <div class="form-group">
                          <mat-form-field style="max-width: 200px;">
                            <mat-label>Date de naissance * :</mat-label>
                            <input matInput required ngModel matInput [matDatepicker]="DateNaissance"
                              name="DateNaissance">
                            <mat-datepicker-toggle matSuffix [for]="DateNaissance"></mat-datepicker-toggle>
                            <mat-datepicker disabled="false" #DateNaissance></mat-datepicker>
                          </mat-form-field>
                        </div>


                        <mat-form-field>
                          <mat-label>Numero CIN</mat-label>
                          <input name="CIN" matInput ngModel placeholder="CIN" required />
                        </mat-form-field>
                        <br />
                        <mat-form-field>
                          <mat-label>Matricule</mat-label>
                          <input name="Matricule" ngModel matInput placeholder="Matricule" />
                        </mat-form-field>
                        <br />
                      </mat-expansion-panel>
                      <mat-expansion-panel [expanded]="true" [disabled]="true" hideToggle="true"
                        style="margin-top: 5px ;width: 100%;">
                        <mat-expansion-panel-header style="background-color: #00bade;max-height:50px;">
                          <mat-panel-title class="accordeonTitle">
                            <strong> Coordonnées</strong>
                          </mat-panel-title>
                        </mat-expansion-panel-header>
                        <mat-form-field style="min-width: 400px">
                          <mat-label>Adresse</mat-label>
                          <input name="Addresse" matInput ngModel placeholder="Addresse" required />
                        </mat-form-field>
                        <br />
                        <mat-form-field>
                          <mat-label>Ville</mat-label>
                          <input name="Ville" matInput ngModel placeholder="Ville" required />
                        </mat-form-field>
                        <br />
                        <mat-form-field>
                          <mat-label>Télephone</mat-label>
                          <input name="Telephone" matInput ngModel placeholder="Télephone" required />
                        </mat-form-field>
                        <br />
                        <mat-form-field>
                          <mat-label>Télephone Secondaire</mat-label>
                          <input name="TelephoneSecond" matInput ngModel placeholder="Télephone Secondaire" />
                        </mat-form-field>
                        <br />
                        <mat-form-field>
                          <mat-label>Email</mat-label>
                          <input name="Email" type="email" matInput ngModel placeholder="Email" email required />
                        </mat-form-field>
                      </mat-expansion-panel>
                      <div style="text-align: right; width:70%;">
                        <button (click)="log(mergeForm(form1))" style="margin: 10px; " class="btn btn-primary" matStepperNext>Suivant</button>
                      </div>
                  </mat-step>
                  <mat-step [stepControl]="second" #second="ngModelGroup" ngModelGroup="second">

                    <ng-template matStepLabel>Formation et expérience</ng-template>
                    <mat-expansion-panel [expanded]="true" [disabled]="true" hideToggle="true"
                      style="margin-top: 5px ;width: 100%;">
                      <mat-expansion-panel-header style="background-color: #00bade;max-height:40px;">
                        <mat-panel-title class="accordeonTitle">
                          <strong> Formations: Diplôme exigé par l'annonce</strong>
                        </mat-panel-title>
                      </mat-expansion-panel-header>
                      <mat-form-field style="min-width: 350px">
                        <mat-label>Intitulé Diplôme</mat-label>
                        <input name="Diplome" matInput ngModel placeholder="Diplome" required />
                      </mat-form-field>

                      <br />
                      <div style="display: inline-flex;">
                        <mat-label style="margin:10px;">Niveau d'étude *: </mat-label> &nbsp;&nbsp;
                        <div>
                          <select ngModel required class="form-control" ngModel required name="NiveauEtude"
                            style="max-width: 200px;">
                            <option value="">Selectionner niveau etude</option>
                            <option value="Bac + 2" title="Bac + 2">Bac + 2</option>
                            <option value="Bac + 3" title="Bac + 3">Bac + 3</option>
                            <option value="Bac + 4" title="Bac + 4">Bac + 4</option>
                            <option value="Bac + 5" title="Bac + 5">Bac + 5</option>
                            <option value="Bac + 6 et plus" title="Bac + 6 et plus">Bac + 6</option>


                          </select>
                        </div>
                      </div>
                      <br />
                      <mat-form-field style="min-width: 350px">
                        <mat-label>Spécialité</mat-label>
                        <input name="Specialite" matInput ngModel placeholder="Spécialité" required />
                      </mat-form-field>
                      <br />
                      <mat-form-field style="min-width: 350px">
                        <mat-label>Ecole ou établissement</mat-label>
                        <input name="Ecole" matInput ngModel placeholder="Ecole ou établissement" required />
                      </mat-form-field>
                      <br />
                      <mat-form-field>
                        <mat-label>Autre formation</mat-label>
                        <input name="AutreFormation" matInput ngModel placeholder="Autre Formation" />
                      </mat-form-field>
                      <br />
                      <mat-form-field>
                        <mat-label>Spécialité</mat-label>
                        <input name="Specialite2" matInput ngModel placeholder="Spécialité" />
                      </mat-form-field>
                      <br />

                    </mat-expansion-panel>
                    <mat-expansion-panel [expanded]="true" [disabled]="true" hideToggle="true"
                      style="margin-top: 5px ;width: 100%;">
                      <mat-expansion-panel-header style="background-color: #00bade;max-height:50px;">
                        <mat-panel-title class="accordeonTitle">
                          <strong> Dernière expérience professionnelle (Hors Stage)</strong>
                        </mat-panel-title>
                      </mat-expansion-panel-header>
                      <mat-form-field>
                        <mat-label>Organisme/Employeur </mat-label>
                        <input name="Organisme" matInput ngModel placeholder="Organisme/Employeur" required />
                      </mat-form-field>
                      <br />
                      <mat-form-field style="min-width: 350px">

                        <mat-label>Intitulé du poste </mat-label>
                        <input name="Poste" matInput ngModel placeholder="Intitulé du poste" required />
                      </mat-form-field>
                      <br />

                      <mat-form-field>
                        <mat-label>Secteur d’activité </mat-label>
                        <input name="Secteur" matInput ngModel placeholder="Secteur d’activité" required />
                      </mat-form-field>
                      <br>
                      <div class="form-group">
                        <mat-form-field style="max-width: 300px;">
                          <mat-label>Date début </mat-label>
                          <input matInput required ngModel matInput [matDatepicker]="DateDebut" name="DateDebut">
                          <mat-datepicker-toggle matSuffix [for]="DateDebut"></mat-datepicker-toggle>
                          <mat-datepicker disabled="false" #DateDebut></mat-datepicker>
                        </mat-form-field>
                      </div>
                      <div class="form-group">
                        <mat-form-field style="max-width: 300px;">
                          <mat-label>Date fin/ jusqu’à aujourd’hui </mat-label>
                          <input matInput required ngModel matInput [matDatepicker]="DateFin" name="DateFin">
                          <mat-datepicker-toggle matSuffix [for]="DateFin"></mat-datepicker-toggle>
                          <mat-datepicker disabled="false" #DateFin></mat-datepicker>
                        </mat-form-field>
                      </div>
                      <mat-form-field>
                        <mat-label>Nombre d’année d’expérience </mat-label>
                        <input type="number" name="NbrExperience" ngModel matInput placeholder="NbrExperience"
                          required />
                      </mat-form-field>
                      <br />

                    </mat-expansion-panel>
                    <div style="text-align: right; width:70%;">
                      <button style="margin: 10px" class="btn btn-primary" matStepperPrevious>Retour</button>
                      &nbsp;&nbsp;
                      <button style="margin: 10px" class="btn btn-primary" matStepperNext>Suivant</button>
                    </div>

                  </mat-step>
                  <mat-step (opened)="createCaptcha()">
                    <ng-template matStepLabel>Dossier de candidature</ng-template>
                    <p style="color:#003d62;"><strong>Les éléments du dossier de candidature sont à scanner, ajouter à
                        un archive (en un seul fichier .zip),Le volume du fichier compressé(.zip) ne doit pas dépasser
                        15 Mo.</strong> </p>
                    <br />
                    <!-- <div class="form-group" style="max-width: 400px;">
                    <label class="control-label">Dossier de candidature *</label>
                    <input required #file ngModel type="file" class="form-control input-lg"  accept=".zip,.rar,.7zip" name="file">
                  </div> -->
                    <div class="form-group" style="max-width: 400px;">
                      <button [disabled]="isFileUploaded != 0 " style="margin: 10px" (click)="chargeIframe(mergeForm(form1))"
                        data-toggle="modal" data-target="#exampleModal" class="btn btn-success">
                        <span *ngIf="isFileUploaded == -1" class="spinner-border spinner-border-sm" role="status"
                          aria-hidden="true"></span>
                        <span *ngIf="isFileUploaded == 1">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                            class="bi bi-check2-all" viewBox="0 0 16 16">
                            <path
                              d="M12.354 4.354a.5.5 0 0 0-.708-.708L5 10.293 1.854 7.146a.5.5 0 1 0-.708.708l3.5 3.5a.5.5 0 0 0 .708 0l7-7zm-4.208 7-.896-.897.707-.707.543.543 6.646-6.647a.5.5 0 0 1 .708.708l-7 7a.5.5 0 0 1-.708 0z" />
                            <path d="m5.354 7.146.896.897-.707.707-.897-.896a.5.5 0 1 1 .708-.708z" />
                          </svg>
                        </span>
                        Dossier candidature
                      </button>
                    </div>
                    <div style="display: inline-flex; height: 45px">
                      <input type="text" id="cpatchaTextBox" />
                      <div class="captchaClass" id="captcha"></div>
                      <a href="javascript:void(0)" (click)="createCaptcha()">
                        <img src="/assets/css/img/reloading.gif" style="
                          width: 35px;
                          height: 35px;
                          padding: 5px;
                          margin: 5px;
                        " alt="reload captcha" Title="Reload captcha" />
                      </a>
                    </div>

                    <div style="text-align: right; width:70%;">
                      <button *ngIf="form1.valid" style="margin: 10px" class="btn btn-success"
                        (click)="uploadCanditature(null,mergeForm(form1))" [disabled]="sending">
                        <span *ngIf="sending" class="spinner-border spinner-border-sm" role="status"
                          aria-hidden="true"></span>
                        <div>Envoyer la candidature</div>
                      </button>
                      <button *ngIf="!form1.valid" style="margin: 10px" class="btn btn-success"
                        [disabled]="!form1.valid" data-toggle="tooltip" data-placement="top"
                        title="Merci de remplir les champs obligatoires">
                        <span *ngIf="sending" class="spinner-border spinner-border-sm" role="status"
                          aria-hidden="true"></span>
                        <div>Envoyer la candidature</div>
                      </button>

                      <!-- <button style="margin: 10px" class="btn btn-primary" (click)="uploadCanditature(file,form1)">Envoyer Candidature</button>&nbsp; -->
                      <button style="margin: 10px" class="btn btn-primary" matStepperPrevious>Retour</button>&nbsp;
                      <button style="margin: 10px" class="btn btn-primary" (click)="stepper.reset()">
                        Annuler
                      </button>
                    </div>
                  </mat-step>
                </mat-vertical-stepper>
              </form>

            </div>
            <div id="container" *ngIf="confirmationMessage ==='Succes'">
              <p>Bonjour ,</p>
              <br />
              <p>
                Nous vous informons que votre candidature au poste de {{TitlePoste}} a été déposée avec succès.,
              </p>
              <br />
              Cordialement,
              <br />
              Agence Nationale des Ports

            </div>
            <div id="container" *ngIf="confirmationMessage ==='Erreur'">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>

<div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Ajouter un fichier</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <iframe id='fileFrame' [src]="fileUploadUrl" frameborder="0" allowfullscreen=""></iframe>

      </div>
    </div>
  </div>
</div>